import React, { useEffect } from 'react';

export const PaymentReturnPage: React.FC = () => {
  useEffect(() => {
    try { window.close(); } catch { /* ignore */ }
  }, []);

  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      fontFamily: 'Manrope, -apple-system, BlinkMacSystemFont, sans-serif',
      background: '#F5F5F5',
    }}>
      <div style={{
        maxWidth: 360,
        width: '100%',
        textAlign: 'center',
        background: '#FFFFFF',
        borderRadius: 20,
        padding: '40px 24px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
      }}>
        <div style={{
          width: 64,
          height: 64,
          borderRadius: 16,
          background: '#E8F5E9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
        }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#43A047" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
          </svg>
        </div>

        <h1 style={{ fontSize: 20, fontWeight: 800, color: '#1A1D1A', margin: '0 0 8px' }}>
          Вернитесь в Telegram
        </h1>
        <p style={{ fontSize: 14, fontWeight: 400, color: '#818384', margin: '0 0 24px', lineHeight: '20px' }}>
          Переключитесь обратно в приложение Telegram — ваш заказ уже там
        </p>

        <button
          onClick={() => { try { window.close(); } catch { /* ignore */ } }}
          style={{
            width: '100%',
            padding: '14px',
            borderRadius: 14,
            border: 'none',
            background: '#3657F0',
            color: '#FFFFFF',
            fontSize: 15,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          Закрыть страницу
        </button>
      </div>
    </div>
  );
};
